import { useMemo } from 'react';
import { useAppStore } from '@/core/stores/appStore';
import {
  mapStoreBankDetailsToAccount,
  type BankTransferAccount,
} from '../constants/bankTransferDetails';

/**
 * Reactive escrow account from profile-details `bank_details` (via auth.user).
 */
export function useBankTransferAccount(): BankTransferAccount | null {
  const accountName = useAppStore((state) => state.auth.user?.bank_beneficiary_name);
  const bankName = useAppStore((state) => state.auth.user?.bank_name);
  const accountNumber = useAppStore((state) => state.auth.user?.bank_account_number);
  const iban = useAppStore((state) => state.auth.user?.bank_iban);
  const swiftCode = useAppStore((state) => state.auth.user?.bank_swift_code);

  return useMemo(
    () =>
      mapStoreBankDetailsToAccount({
        accountName,
        bankName,
        accountNumber,
        iban,
        swiftCode,
      }),
    [accountName, bankName, accountNumber, iban, swiftCode],
  );
}
